import { useHistory, useParams } from "react-router-dom";

export interface PortalPathParams {
  partnerSlug: string;
  subscriptionId: string;
}

export const getPortalPaths = (params?: PortalPathParams) => {
  const partnerSlug = params?.partnerSlug ?? ":partnerSlug";
  const subscriptionId = params?.subscriptionId ?? ":subscriptionId";

  const offeringDetails = (offeringSlug: string, spaceId?: string) => {
    let path = `/offerings/${offeringSlug}`;
    if (spaceId) {
      path += `/spaces/${spaceId}`;
    }
    return path;
  };

  return {
    home: `/portal/${partnerSlug}`,
    membership: `/portal/${partnerSlug}/membership/${subscriptionId}`,
    manageMembership: `/portal/${partnerSlug}/membership/${subscriptionId}/manage`,
    meetingRooms: `/portal/${partnerSlug}/membership/${subscriptionId}/meeting-rooms`,
    allBookings: `/portal/${partnerSlug}/all-bookings`,
    offeringDetails,
  };
};

export function usePortalHistory() {
  const { subscriptionId, partnerSlug } = useParams<PortalPathParams>();
  const history = useHistory();
  const paths = getPortalPaths({ partnerSlug, subscriptionId });

  return {
    toHome: () => history.push(paths.home),
    toMembershipPage: (id?: string) =>
      history.push(
        getPortalPaths({ partnerSlug, subscriptionId: id ?? subscriptionId })
          .membership
      ),
    toManageMembershipPage: () => history.push(paths.manageMembership),
    toMeetingRoomsPage: () => history.push(paths.meetingRooms),
    toAllBookingsPage: () => history.push(paths.allBookings),
    toOfferingDetailsPage: (offeringSlug: string, spaceId?: string) =>
      history.push(paths.offeringDetails(offeringSlug, spaceId)),
  };
}
